// pdfMakeSetup.js
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// ⚡ Vérification pour éviter l'erreur
if (pdfFonts && pdfFonts.pdfMake) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
} else {
  console.error("Erreur : pdfFonts.pdfMake est undefined !");
}

export default pdfMake;
